import { storageGet } from '../libs/localStorage';

export default () => {
  const compareListObject = storageGet('compare');

  if (compareListObject) {
    return Object.keys(compareListObject);
  }

  return [];
};
